import { t } from "i18next";
import { TFuncKey } from "react-i18next";
import OptionalMaybe from "types/OptionalMaybe";
import { TrailerSize } from "types/TrailerSize";

const sizeMapToI18nKey: Record<TrailerSize, TFuncKey<"common">> = {
  T_26: "trailerSizes.T_26",
  T_40: "trailerSizes.T_40",
  T_48: "trailerSizes.T_48",
  T_53: "trailerSizes.T_53",
  C_20: "trailerSizes.C_20",
  C_40: "trailerSizes.C_40",
  C_20_HC: "trailerSizes.C_20_HC",
  C_40_HC: "trailerSizes.C_40_HC",
  C_45_HC: "trailerSizes.C_45_HC",
  NA: "trailerSizes.NA",
};

const sizeMapToI18n: Record<TrailerSize, TFuncKey<"common", "trailerSizes">> = {
  T_26: t(sizeMapToI18nKey.T_26, { ns: "common" }),
  T_40: t(sizeMapToI18nKey.T_40, { ns: "common" }),
  T_48: t(sizeMapToI18nKey.T_48, { ns: "common" }),
  T_53: t(sizeMapToI18nKey.T_53, { ns: "common" }),
  C_20: t(sizeMapToI18nKey.C_20, { ns: "common" }),
  C_40: t(sizeMapToI18nKey.C_40, { ns: "common" }),
  C_20_HC: t(sizeMapToI18nKey.C_20_HC, { ns: "common" }),
  C_40_HC: t(sizeMapToI18nKey.C_40_HC, { ns: "common" }),
  C_45_HC: t(sizeMapToI18nKey.C_45_HC, { ns: "common" }),
  NA: t(sizeMapToI18nKey.NA, { ns: "common" }),
};

/**
 * @deprecated Stop using this function. Prefer just using useTranslation + i18n directly
 * @todo refactor to remove usage of this function
 */
export const getFtlTrailerSize = (size: OptionalMaybe<TrailerSize>, showNA = false): string => {
  if (!size) {
    return "";
  }

  if (size === "NA" && !showNA) {
    return "";
  }

  return sizeMapToI18n[size];
};
